import { IPurchasingGroupDto } from '../types/purchasing-group.dto';

export class PurchasingGroup {
    public readonly id: string;
    public readonly code: string;
    public readonly name: string;
    public readonly description: string | null;
    public readonly active: boolean;
    public readonly companyCodes: ReadonlyArray<string>;
    public readonly materialGroupCodes: ReadonlyArray<string>;
    public readonly memberIds: ReadonlyArray<string>;

    constructor(dto: IPurchasingGroupDto) {
        this.id = dto.id;
        this.code = dto.code;
        this.name = dto.name;
        this.description = dto.description ?? null;
        this.active = dto.active;
        this.companyCodes = dto.companyCodes ? [...dto.companyCodes] : [];
        this.materialGroupCodes = dto.materialGroupCodes ? [...dto.materialGroupCodes] : [];
        this.memberIds = dto.memberIds ? [...dto.memberIds] : [];
    }
}
